import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import LoadsPage from "components/LoadsPage";
import {
  useAddEVBatteryStateLoadsMutation,
  useGetEVBatteryStateLoadsByCommunityIdPaginationQuery,
} from "state/evs/evApiSlice";

function ManageEVBatteryStateLoads({ noWrapper }) {
  const { t } = useTranslation(["internalLoads"]);
  return (
    <LoadsPage
      title={t("pages.ev_battery_state.title")}
      subtitle={t("pages.ev_battery_state.subtitle")}
      taskType="EV_BATTERY_STATE_LOAD"
      templateHref="/docs/template_bateria.csv"
      addMutation={useAddEVBatteryStateLoadsMutation}
      noWrapper={noWrapper}
      table={{
        query: useGetEVBatteryStateLoadsByCommunityIdPaginationQuery,
        resourceField: "ev_id",
        resourceLabel: t("pages.ev_battery_state.table.columns.ev"),
        resourceType: "EV",
        valueLabel: { field: "battery_state", label: t("shared.columns.charge_state") },
        valueDigits: 2,
      }}
    />
  );
}

ManageEVBatteryStateLoads.propTypes = {
  noWrapper: PropTypes.bool,
};

ManageEVBatteryStateLoads.defaultProps = {
  noWrapper: false,
};

export default ManageEVBatteryStateLoads;
